export default __webpack_public_path__ + "static/media/501.2708bd3b.png";